import { Plus, Trash2, Save, Star, ChevronUp, ChevronDown, ImageOff } from "lucide-react";
import { useCrud } from "./useCrud";
import { Field, ImageField } from "./ImageField";

export const GalleryEditor = () => {
  const { items, patch, add, save, remove, move } = useCrud("gallery-items", { url: "", title: "", category: "", featured: false });
  const cats = [...new Set(items.map((i) => i.category).filter(Boolean))].sort();

  const toggleFeatured = (b) => { const next = { ...b, featured: !b.featured }; patch(b.id, "featured", next.featured); save(next); };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between gap-4">
        <p className="text-[#8F877C] text-sm">Curate the public Gallery. Add images by pasting a URL or uploading, then group them into albums (e.g. Events, Landscapes, Characters) — separate from the player Upload tool.</p>
        <button onClick={add} data-testid="gallery-add-btn" className="inline-flex shrink-0 items-center gap-2 font-feature text-xs uppercase tracking-widest bg-teal text-obsidian px-4 py-2.5 hover:bg-bone transition-colors"><Plus className="h-4 w-4" /> Add Image</button>
      </div>
      <datalist id="gallery-category-options">
        {cats.map((c) => <option key={c} value={c} />)}
      </datalist>

      {items.length === 0 && (
        <div className="border border-dashed border-[#2A201A] py-16 text-center">
          <ImageOff className="mx-auto h-7 w-7 text-[#5c554c]" />
          <p className="mt-3 text-[#8F877C] text-sm">No gallery images yet. Click “Add Image” to load your first one.</p>
        </div>
      )}

      <div className="grid gap-3 sm:grid-cols-2">
        {items.map((b, idx) => (
          <div key={b.id} data-testid={`gallery-edit-${b.id}`} className="border border-[#2A201A] bg-surface/40 p-4 space-y-3">
            <ImageField label="Image (URL or upload)" value={b.url} onChange={(v) => patch(b.id, "url", v)} scope="gallery" />
            <Field label="Caption (optional)" value={b.title} onChange={(v) => patch(b.id, "title", v)} />
            <div>
              <p className="font-mono text-[10px] uppercase tracking-widest text-[#8F877C] mb-2">Album / Category</p>
              <input value={b.category || ""} list="gallery-category-options" placeholder="e.g. Events, Landscapes, Characters"
                onChange={(e) => patch(b.id, "category", e.target.value)}
                className="w-full bg-obsidian border border-[#2A201A] px-3 py-2.5 text-sm text-bone focus:outline-none focus:border-teal" />
            </div>
            <div className="flex items-center gap-2">
              <button type="button" onClick={() => toggleFeatured(b)} data-testid={`gallery-feature-${b.id}`}
                className={`inline-flex items-center gap-2 font-feature text-[11px] uppercase tracking-wider border px-3 py-2 transition-colors ${b.featured ? "border-gold bg-gold text-obsidian" : "border-[#2A201A] text-[#8F877C] hover:border-gold hover:text-gold"}`}>
                <Star className="h-3.5 w-3.5" fill={b.featured ? "currentColor" : "none"} /> {b.featured ? "Featured" : "Feature"}
              </button>
              <button onClick={() => move(idx, -1)} title="Move up" className="p-2 border border-[#2A201A] hover:border-teal hover:text-teal transition-colors"><ChevronUp className="h-3.5 w-3.5" /></button>
              <button onClick={() => move(idx, 1)} title="Move down" className="p-2 border border-[#2A201A] hover:border-teal hover:text-teal transition-colors"><ChevronDown className="h-3.5 w-3.5" /></button>
              <button onClick={() => save(b)} className="ml-auto inline-flex items-center gap-2 font-feature text-xs uppercase tracking-widest bg-teal/90 text-obsidian px-4 py-2 hover:bg-teal"><Save className="h-4 w-4" /> Save</button>
              <button onClick={() => remove(b.id)} title="Delete" className="p-2 border border-[#2A201A] text-[#8F877C] hover:border-destructive hover:text-destructive transition-colors"><Trash2 className="h-4 w-4" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
